import { useMemo } from "react";
import instagramIcon from "../../assets/icon/instagram.svg";
import tiktiokIcon from "../../assets/icon/tiktok.svg";
import facebookIcon from "../../assets/icon/facebook.svg";
import emailIcon from "../../assets/icon/email.svg";
import telphoneIcon from "../../assets/icon/telphone.svg";
import whatsAppIcon from "../../assets/icon/WhatsApp.svg";
import pinLocationIcon from "../../assets/icon/pinPoinLocation.svg";

import background from "../../assets/img/backgorund.png";
import FooterSection from "../../commponents/layout/Footer";
import { useHomePage } from "../../context/HomePageContext";

import {
  toInstagramHref,
  toMapsHref,
  toSocialHandle,
  toTelHref,
  toWhatsappHref,
} from "../../lib/contactLinks";
import { resolveContactPage } from "../../lib/homePageContent";

// Email, telepon, WhatsApp, Instagram, dan kedua alamat dikelola dari admin
// (menu Home Page -> Footer & Contact), data yang sama dengan Footer.
// TikTok & Facebook BELUM ada di CMS -> ganti manual sesuai akun resmi.
const SOCIAL_NOT_IN_CMS = {
  tiktok: "arunikamedinapratama",
  facebook: "arunikamedinapratama",
};

const MAPS_BUTTON_CLASS = `
  inline-block
  mt-8
  px-12
  py-3
  rounded-full
  border
  border-white/50
  text-white
  font-semibold
  backdrop-blur-sm
  hover:bg-white/10
  transition
`;

export default function ContactPage() {
  const { data, status } = useHomePage();
  const contact = useMemo(() => resolveContactPage(data?.footer), [data]);

  const backdrop = (
    <>
      {/* BACKGROUND */}
      <img
        src={background}
        alt=""
        className="
          absolute
          inset-0
          w-full
          h-full
          object-cover
        "
      />

      {/* OVERLAY */}
      <div className="absolute inset-0 bg-[#355260]/40" />
    </>
  );

  // Kunjungan pertama: tunggu data dari admin sebentar supaya kontak bawaan
  // tidak sempat tampil lalu berganti.
  if (status === "loading") {
    return (
      <section className="relative min-h-screen overflow-hidden">
        {backdrop}

        <div
          role="status"
          aria-label="Loading"
          className="relative z-10 flex min-h-screen items-center justify-center">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-white/40 border-t-white" />
        </div>
      </section>
    );
  }

  return (
    <section className="relative min-h-screen overflow-hidden">
      {backdrop}

      {/* CONTENT */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 pt-[120px] pb-20">
        {/* TITLE */}
        <h1 className="text-white text-5xl font-bold mb-10">Contact</h1>

        {/* CONTACT CARD */}
        <div
          className="
            bg-[#ECECEC]
            rounded-[32px]
            p-8
            lg:p-12
            shadow-lg
          ">
          <div className="grid md:grid-cols-2 gap-12">
            {/* LEFT */}
            <div>
              {contact.email && (
                <>
                  <h2 className="text-[#324A5A] text-3xl font-bold mb-8">
                    Email
                  </h2>

                  <div className="flex items-start gap-4">
                    <img
                      src={emailIcon}
                      alt=""
                      className="w-8 h-8 shrink-0 mt-1"
                    />

                    <div className="min-w-0 flex-1">
                      <a
                        href={`mailto:${contact.email}`}
                        className="
                    break-all
                    text-sm
                    sm:text-base
                    lg:text-2xl
                  ">
                        {contact.email}
                      </a>
                    </div>
                  </div>
                </>
              )}

              {(contact.phone || contact.whatsapp) && (
                <>
                  <h2
                    className={`text-[#324A5A] text-3xl font-bold ${
                      contact.email ? "mt-12" : ""
                    } mb-8`}>
                    Phone
                  </h2>

                  <div className="space-y-4">
                    {contact.phone && (
                      <div className="flex items-center gap-4 text-xl lg:text-2xl">
                        <img src={telphoneIcon} alt="" className="w-8 h-8" />
                        <a href={toTelHref(contact.phone)}>{contact.phone}</a>
                      </div>
                    )}

                    {contact.whatsapp && (
                      <div className="flex items-center gap-4 text-xl lg:text-2xl">
                        <img src={whatsAppIcon} alt="" className="w-8 h-8" />
                        <a
                          href={toWhatsappHref(contact.whatsapp)}
                          target="_blank"
                          rel="noopener noreferrer">
                          {contact.whatsapp}
                        </a>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>

            {/* RIGHT */}
            <div>
              <h2 className="text-[#324A5A] text-3xl font-bold mb-8">
                Media Social
              </h2>

              <div className="space-y-6">
                {contact.instagram && (
                  <div className="flex items-center gap-4">
                    <img src={instagramIcon} alt="" className="w-8 h-8" />
                    <a
                      href={toInstagramHref(contact.instagram)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xl lg:text-2xl">
                      {toSocialHandle(contact.instagram)}
                    </a>
                  </div>
                )}

                <div className="flex items-center gap-4">
                  <img src={tiktiokIcon} alt="" className="w-8 h-8" />
                  <span className="text-xl lg:text-2xl">
                    {SOCIAL_NOT_IN_CMS.tiktok}
                  </span>
                </div>

                <div className="flex items-center gap-4">
                  <img src={facebookIcon} alt="" className="w-8 h-8" />
                  <span className="text-xl lg:text-2xl">
                    {SOCIAL_NOT_IN_CMS.facebook}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* HEAD OFFICE */}
        <div className="text-center mt-20">
          <h2 className="text-white text-5xl font-bold mb-8">Head Office</h2>

          <div className="flex flex-wrap justify-center items-center gap-4 text-white text-xl lg:text-3xl">
            <img src={pinLocationIcon} alt="" className="w-8 h-8" />

            <span className="whitespace-pre-line">{contact.headOffice}</span>
          </div>

          <a
            href={toMapsHref(contact.headOffice)}
            target="_blank"
            rel="noopener noreferrer"
            className={MAPS_BUTTON_CLASS}>
            Lihat Maps
          </a>
        </div>

        {/* WORKSHOP */}
        <div className="text-center mt-20">
          <h2 className="text-white text-5xl font-bold mb-8">Workshop</h2>

          <div className="flex flex-wrap justify-center items-center gap-4 text-white text-xl lg:text-3xl">
            <img src={pinLocationIcon} alt="" className="w-8 h-8" />

            <span className="whitespace-pre-line">{contact.workshop}</span>
          </div>

          <a
            href={toMapsHref(contact.workshop)}
            target="_blank"
            rel="noopener noreferrer"
            className={MAPS_BUTTON_CLASS}>
            Lihat Maps
          </a>
        </div>
      </div>
      <FooterSection />
    </section>
  );
}
